// slider 1
setTimeout(function() {
    var swiper = new Swiper(".projectsOneSwiper", {
      slidesPerView: "1.1",
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
          1024: {
            slidesPerView: "1.1",
            spaceBetween: 10,
        },
           992: {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesPerView: "1",
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesPerView: "1",
        },
         425: {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesPerView: "1",
        },
         325: {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesPerView: "1",
        }
      },
    });
}, 400);
// slider 2
setTimeout(function() {
    var swiper = new Swiper(".projectsSecondSwiper", {
      slidesPerView: "2.2",
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
          1024: {
            slidesPerView: "2.2",
      spaceBetween: 10,
        },
           992: {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesPerView: "1",
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesPerView: "1",
        },
         425: {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesPerView: "1",
        },
         325: {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesPerView: "1",
        }
      },
    });
}, 400);
// slider 3
setTimeout(function() {
    var swiper = new Swiper(".projectsThirdSwiper", {
      slidesPerView: "1",
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
          1024: {
            slidesPerView: "1",
      spaceBetween: 10,
        },
           992: {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesPerView: "1",
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesPerView: "1",
        },
         425: {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesPerView: "1",
        },
         325: {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesPerView: "1",
        }
      },
    });
}, 400);
  
// slider 4
setTimeout(function() {
    var swiper = new Swiper(".projectsFourSwiper", {
      slidesPerView: "2",
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
          1024: {
            slidesPerView: "2",
      spaceBetween: 10,
        },
           992: {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesPerView: "1",
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesPerView: "1",
        },
         425: {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesPerView: "1",
        },
         325: {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesPerView: "1",
        }
      },
    });
}, 400);

// Home slider
setTimeout(function() {
    var swiper = new Swiper(".projectsHomeSwiper", {
      slidesPerView: "1",
      spaceBetween: 10,
     // If you need pagination
      pagination: {
        el: '.swiper-pagination',
      type: 'fraction',
      },
 
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    breakpoints: {
          1024: {
            slidesPerView: "1",
      spaceBetween: 10,
        },
           992: {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesPerView: "1",
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesPerView: "1",
        },
         425: {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesPerView: "1",
        },
         325: {
          slidesPerView: 1,
          spaceBetween: 10,
          slidesPerView: "1",
        }
      },
    });
}, 400);